import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

import SelectOption from '../../components/Inputs/Select/Select';
import Toast from '../../components/Toast/Toast';

import UFService from '../../services/UF';
import { patternUF } from '../../variables/Enums/UF';

import CidadeService from '../../services/Cidade';
import { patternCityObmep, patternRegion } from '../../variables/Enums/Cidade';

import { isCoordenador, isApoioSecretarial, isCoordenadorOuApoioSecretarial } from '../../security/AuthorizedFunction';
import {
    getCoordenadorUF,
    getCoordenadorRegiao,
    getApoioSecretarialUF,
    getApoioSecretarialRegiao,
} from '../../security/keycloak';

export class LocalProvaFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                ufProva: !this.props.habilitarFiltroCR ? isCoordenador() ? getCoordenadorUF() : isApoioSecretarial() ? getApoioSecretarialUF() : '' : '',
                regiaoProva: !this.props.habilitarFiltroCR ? isCoordenador() ? getCoordenadorRegiao() : isApoioSecretarial() ? getApoioSecretarialRegiao() : '' : '',
                municipioProva: '',
            },
            disabled: {
                ufProva: isCoordenadorOuApoioSecretarial() && this.props.disabledFiltroCR ? true : false,
                regiaoProva: isCoordenadorOuApoioSecretarial() && this.props.disabledFiltroCR ? true : false,
                municipioProva: isCoordenadorOuApoioSecretarial() && this.props.disabledFiltroCR ? false : true,
            },
            optionsUF: [],
            optionsRegion: [],
            optionsCity: [],
            loadingOptionsUF: false,
            loadingOptionsRegion: false,
            loadingOptionsCity: false,
        }
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value },
        }, () => {
            if (e.target.name === 'ufProva' || e.target.name === 'regiaoProva') 
                this.findCities(false, e.target.name !== 'regiaoProva');
        });
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;

    // BUSCAR MUNICIPIOS POR UF E REGIAO SELECIONADOS
    findCities = (manterCidade = false, manterRegiao = true) => {
        if (!this.props.disabledCities) {
            if (!this.state.filters.ufProva && !this.state.filters.regiaoProva) {
                this.limparBuscas();
                return
            }

            if (manterRegiao)
                this.carregarRegioes();

            this.carregarCidades(manterCidade);
        }
    }

    carregarUFs = () => {
        this.setState({ loadingOptionsUF: true });

        UFService.list()
            .then(res => {
                this.setState({
                    filters: {
                        ...this.state.filters,
                        ufProva: !this.props.habilitarFiltroCR ? isCoordenador() ? getCoordenadorUF() : isApoioSecretarial() ? getApoioSecretarialUF() : '' : '',
                    },
                    optionsUF: [...patternUF(res.data.content)]
                })
            })
            .catch(err => {
                this.Toast.setState({
                    message: {
                        message: "Não Foi Possível Buscar as UF's.",
                        type: 'error',
                        open: true
                    }
                })
            })
            .finally(() => this.setState({ loadingOptionsUF: false }))
    }

    carregarRegioes = () => {

        this.setState({ loadingOptionsRegion: true });

        const f = [];

        if (this.state.filters.ufProva) f.push({ field: "uf", value: this.state.filters.ufProva });

        CidadeService.filterRegioes(f)
            .then(res => {
                this.setState({
                    filters: {
                        ...this.state.filters,
                        regiaoProva: this.state.filters.regiaoProva.includes(this.state.filters.ufProva) ? this.state.filters.regiaoProva : '',
                    },
                    optionsRegion: [...patternRegion(res.data.content, this.props.withRegionRJ04)]
                })
            })
            .catch(err => {
                this.Toast.setState({
                    message: {
                        message: "Não Foi Possível Buscar as Regiões.",
                        type: 'error',
                        open: true
                    }
                })
            })
            .finally(() => this.setState({ loadingOptionsRegion: false }))

    }

    carregarCidades = (manterCidade = false) => {
        const f = [];

        const uf = this.state.filters.ufProva || (this.state.filters.regiaoProva ? this.state.filters.regiaoProva.substring(0, 2) : null);

        if (uf) f.push({ field: "uf", value: uf });

        if (f.length > 0) {
            this.setState({ loadingOptionsCity: true });

            CidadeService.findLocaisProvaObmepUltimosCincoAnos(f)
                .then(res => {
                   
                    const cidadesFiltradas = res.data.filter(
                        cidade => !this.state.filters.regiaoProva || cidade.regiao === this.state.filters.regiaoProva
                    );

                    this.setState({
                        filters: {
                            ...this.state.filters,
                            municipioProva: manterCidade ? this.state.filters.municipioProva : '',
                        },
                        disabled: {
                            ...this.state.disabled,
                            municipioProva: false,
                        },
                        optionsCity: [...patternCityObmep(cidadesFiltradas)]
                    })
                })
                .catch(err => {
                    this.Toast.setState({
                        message: {
                            message: "Não Foi Possível Buscar as Cidades com Locais de Provas.",
                            type: 'error',
                            open: true
                        }
                    })
                })
                .finally(() => this.setState({ loadingOptionsCity: false }))
        }
    }

    limparBuscas = () => {
        this.setState({
            filters: {
                ufProva: !this.props.habilitarFiltroCR ? isCoordenador() ? getCoordenadorUF() : isApoioSecretarial() ? getApoioSecretarialUF() : '' : '',
                regiaoProva: !this.props.habilitarFiltroCR ? isCoordenador() ? getCoordenadorRegiao() : isApoioSecretarial() ? getApoioSecretarialRegiao() : '' : '',
                municipioProva: '',
            },
            disabled: {
                ufProva: isCoordenadorOuApoioSecretarial() && this.props.disabledFiltroCR ? true : false,
                regiaoProva: isCoordenadorOuApoioSecretarial() && this.props.disabledFiltroCR ? true : false,
                municipioProva: isCoordenadorOuApoioSecretarial() && this.props.disabledFiltroCR ? true : false,
            },
            optionsCity: isCoordenadorOuApoioSecretarial() ? this.state.optionsCity : [],
            loadingOptionsUF: false,
            loadingOptionsRegion: false,
            loadingOptionsCity: false,
        }, () => this.carregarRegioes());
    }

    componentDidMount() {
        this.carregarUFs();
        this.carregarRegioes();
        this.carregarCidades();
    }

    render() {
        return (
            <>
                <Toast parentRef={this.setToast} />
                <Grid item sm={12} lg={2}>
                    <SelectOption
                        label={`UF do Local de Prova ${this.props.labelSufix ? ` ${this.props.labelSufix}` : ''}`}
                        name='ufProva'
                        value={!this.props.habilitarFiltroCR ? isCoordenador() ? getCoordenadorUF() : isApoioSecretarial() ? getApoioSecretarialUF() : this.state.filters.ufProva : this.state.filters.ufProva}
                        onChange={this.handleChange}
                        options={this.state.optionsUF}
                        disabled={this.state.loadingOptionsUF || this.state.disabled.ufProva}
                        InputProps={{
                            startAdornment: this.state.loadingOptionsUF ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                        }}
                    />
                </Grid>

                <Grid item sm={12} lg={2}>
                    <SelectOption
                        label="Região"
                        name='regiaoProva'
                        value={!this.props.habilitarFiltroCR ? isCoordenador() ? getCoordenadorRegiao() : isApoioSecretarial() ? getApoioSecretarialRegiao() : this.state.filters.regiaoProva : this.state.filters.regiaoProva}
                        onChange={this.handleChange}
                        options={this.state.optionsRegion}
                        disabled={this.state.loadingOptionsRegion || this.state.disabled.regiaoProva}
                        InputProps={{
                            startAdornment: this.state.loadingOptionsRegion ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                        }}
                    />
                </Grid>

                {!this.props.disabledCities &&
                    <Grid item sm={12} lg={3}>
                        <SelectOption
                            label={`Município do Local de Prova ${this.props.labelSufix ? ` ${this.props.labelSufix}` : ''}`}
                            name='municipioProva'
                            value={this.state.filters.municipioProva}
                            onChange={this.handleChange}
                            options={this.state.optionsCity}
                            disabled={this.state.loadingOptionsCity || this.state.disabled.municipioProva}
                            InputProps={{
                                startAdornment: this.state.loadingOptionsCity ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                            }}
                        />
                    </Grid>
                }
            </>
        )
    }
}

export default LocalProvaFilter;